import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


const Icon = ({ name, width, height, iconColor, className, onHover, icons, margin }) => {
    const SVG = styled.svg`
        width: ${width};
        height: ${height};
        fill: ${props => iconColor ? iconColor.split('.').reduce((o, i) => o[i], props.theme.palette) : props.theme.palette.common.lightBlack};
        margin: ${margin || 'inherit'};
       
        &:hover {
          fill: ${props => onHover ? props.theme.palette.common[onHover] : props.theme.palette.common[iconColor]};
        }
    `;


    return (
        <SVG className={className}>
            <use xlinkHref={`${icons}#${name}`} />
        </SVG>
    );
};

Icon.defaultProps = ({
    width: '100%',
    height: '100%',
    iconColor: null,
    className: null,
    onHover: null,
    icons: null,
});

Icon.propTypes = ({
    name: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    iconColor: PropTypes.string,
    className: PropTypes.string,
    onHover: PropTypes.string,
    icons: PropTypes.string,
});

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const { icons } = initialState.icons;
    const mapStateToProps = state => ({
        icons,
        ...initialOwnProps,
    });
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(Icon);



// WEBPACK FOOTER //
// ./src/components/Icon.js